import { useCallback } from 'react';
import { modalComponentList } from './modalComponentList';
import useGlobalModalStore from './stores/useGlobalModalStore';
import { GlobalModalType } from './types';

const GlobalModalManager = () => {
  const [activeModal, modalProps, setActiveModal] = useGlobalModalStore((s) => [
    s.activeModal,
    s.modalProps,
    s.setActiveModal,
  ]);

  const getActiveModal = useCallback(
    (modalType: GlobalModalType) => modalType === activeModal,
    [activeModal],
  );

  return (
    <>
      {Object.entries(modalComponentList).map(([key, ModalComponent]) => {
        const isActive = getActiveModal(key as GlobalModalType);
        return (
          isActive && (
            <ModalComponent
              key={key}
              visible={isActive}
              onCancel={() => {
                setActiveModal();
              }}
              {...modalProps[key]}
            />
          )
        );
      })}
    </>
  );
};

export default GlobalModalManager;
